import FileGalleryList from './FileGalleryList'
// Uncomment the below to migrate to stateful component
// import FileGalleryListContainer from './FileGalleryListContainer'

export { FileGalleryList }
export default FileGalleryList
// Uncomment the below to migrate to stateful component
// export { FileGalleryList, FileGalleryListContainer }
// export default FileGalleryListContainer



// WEBPACK FOOTER //
// ./src/components/FileGalleryList/index.js